import { useEffect } from "react";
import { useGetVehicleTypesQuery } from "../../api/vehicleTypes";
import { actions } from "../../redux/store/store";

export function useVehicleType(enabled = true) {
  const { data: vehicleTypes } = useGetVehicleTypesQuery(null, {
    refetchOnMountOrArgChange: false,
    skip: !enabled,
  });

  useEffect(() => {
    if (!enabled) return;
    actions.vehicleType.setVehicleTypes(
      vehicleTypes?.map((item) => ({
        value: item?._id,
        label: item?.name,
        title: item?.title
      })) || [])
  }, [vehicleTypes, enabled]);
}
